import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31b4f7f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-summary" }
const _hoisted_2 = { class: "mb-x6" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "inline-block min-w-35" }
const _hoisted_5 = { class: "mr-x2" }
const _hoisted_6 = { class: "whitespace-nowrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-x4" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "order-summary-line-wrap text-13 mb-x2"
}
const _hoisted_9 = { class: "whitespace-nowrap" }
const _hoisted_10 = {
  key: 1,
  class: "order-summary-line-wrap text-13 mb-x2"
}
const _hoisted_11 = { class: "whitespace-nowrap" }
const _hoisted_12 = {
  key: 0,
  class: "order-summary-line-wrap text-13 mb-x2"
}
const _hoisted_13 = { class: "whitespace-nowrap" }
const _hoisted_14 = { class: "whitespace-nowrap" }
const _hoisted_15 = { class: "whitespace-nowrap" }
const _hoisted_16 = { class: "order-summary-line-wrap text-20 mb-x1" }
const _hoisted_17 = { class: "whitespace-nowrap" }
const _hoisted_18 = { class: "order-summary-line-wrap text-13" }
const _hoisted_19 = { class: "whitespace-nowrap" }
const _hoisted_20 = {
  key: 2,
  class: "order-summary-line-wrap text-13"
}
const _hoisted_21 = { class: "whitespace-nowrap" }

import { useCheckout } from '@/b2c/checkout/useCheckout';
import AnimateValue from '@/core/ui-components/AnimateValue.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutOrderSummary',
  setup(__props) {

const labels = useBlockLabels();
const { items, summary } = useCheckout();

const summaryTotalLabel = computed<string>(() => {
    if (summary.value.freightPriceTotal) {
        return labels.orderSummaryTotalIncShipping;
    } else {
        return labels.orderSummaryTotal;
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(labels).orderSummaryHeader), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
      return (_openBlock(), _createElementBlock("dl", {
        key: item.id,
        class: "flex flex-row flex-nowrap justify-between text-13 mb-5 last:mb-0"
      }, [
        _createElementVNode("dt", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(item.quantity), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1)
        ]),
        _createElementVNode("dd", _hoisted_6, _toDisplayString(item.price?.salesPriceTotal?.amount), 1)
      ]))
    }), 128)),
    _hoisted_7,
    (_unref(summary).salesPriceSubTotal)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_8, [
          _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummarySubtotal), 1),
          _createElementVNode("dd", _hoisted_9, _toDisplayString(_unref(summary).listPriceTotal?.amount), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(summary).discountTotal)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_10, [
          _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryDiscount), 1),
          _createElementVNode("dd", _hoisted_11, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).orderSummaryDiscountAmount, { amount: _unref(summary).discountTotal.amount })), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "o-anim-fade-200",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(summary).freightPriceTotal)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_12, [
              _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryShippingPrice), 1),
              _createElementVNode("dd", _hoisted_13, [
                _createVNode(AnimateValue, {
                  value: _unref(summary).freightPriceTotal.amount
                }, null, 8, ["value"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_TransitionGroup, {
      name: "o-anim-fade-200",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summary).deliveryOptions, (deliveryOption) => {
          return (_openBlock(), _createElementBlock("dl", {
            key: deliveryOption.sku,
            class: "order-summary-line-wrap text-13 mb-x2"
          }, [
            _createElementVNode("dt", null, _toDisplayString(deliveryOption.description), 1),
            _createElementVNode("dd", _hoisted_14, [
              (deliveryOption.price.amount)
                ? (_openBlock(), _createBlock(AnimateValue, {
                    key: 0,
                    value: deliveryOption.price.amount
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_TransitionGroup, { name: "o-anim-fade-300" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summary).serviceItemsTotals, (item) => {
          return (_openBlock(), _createElementBlock("dl", {
            key: item.sku,
            class: "order-summary-line-wrap text-13 mb-x2"
          }, [
            _createElementVNode("dt", null, _toDisplayString(item.name) + " (" + _toDisplayString(item.quantity) + ") ", 1),
            _createElementVNode("dd", _hoisted_15, [
              _createVNode(AnimateValue, {
                value: item.Price.amount
              }, null, 8, ["value"])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("dl", _hoisted_16, [
      _createElementVNode("dt", null, [
        _createVNode(AnimateValue, { value: _unref(summaryTotalLabel) }, null, 8, ["value"])
      ]),
      _createElementVNode("dd", _hoisted_17, [
        (_unref(summary).salesPriceTotal?.amount)
          ? (_openBlock(), _createBlock(AnimateValue, {
              key: 0,
              value: _unref(summary).salesPriceTotal.amount
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("dl", _hoisted_18, [
      _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummarySalesTax), 1),
      _createElementVNode("dd", _hoisted_19, _toDisplayString(_unref(summary)?.salesTax?.amount), 1)
    ]),
    (_unref(summary).ecoTaxTotal)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_20, [
          _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryEcoTax), 1),
          _createElementVNode("dd", _hoisted_21, _toDisplayString(_unref(summary).ecoTaxTotal.amount), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})